import Endpoints from "../constants/Endpoints";
import Crud from "./Crud";

export default Crud(Endpoints.auditTrails)